import React from "react";
import instance from "../../services/ApiServices";
import { useState, useEffect } from "react";
import Foodimage from "./foodmenu.jpg";
import Drinkimage from "./drinksmenu.jpg";
import { motion } from "motion/react";
import { Link } from "react-router-dom";

function Menu() {
  return (
    <div
      id="menu"
      className="container flex flex-col sm:flex-row items-stretch gap-8 my-20 p-0"
    >
      <motion.div
        whileHover={{ scale: 1.05, opacity: 0.8 }}
        initial={{ x: -100, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
          transition: {
            delay: 0.5,
            x: { type: "spring", stiffness: 60 },
            opacity: { duration: 0.6 },
            ease: "easeIn",
          },
        }}
        // viewport={{ once: true, amount: 0.8 }}
        className="relative  w-full"
      >
        <Link to="/foodmenu">
          <img
            src={Foodimage}
            alt=""
            className="object-cover"
            // rounded-xl"
          />

          <motion.h2
            initial={{ x: -100, opacity: 0 }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            className="text-4xl font-bold text-center absolute w-full py-4 bottom-0 inset-x-0 bg-secondary text-white"
          >
            Food Menu
          </motion.h2>
        </Link>
      </motion.div>

      {/* {Image Section} */}

      <motion.div
        whileHover={{ scale: 1.05, opacity: 0.8 }}
        initial={{ x: 100, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
          transition: {
            delay: 0.5,
            x: { type: "spring", stiffness: 60 },
            opacity: { duration: 0.6 },
            ease: "easeIn",
          },
        }}
        // viewport={{ once: true, amount: 0.8 }}
        className="relative  w-full"
      >
        <Link to="/drinksmenu">
          <img
            src={Drinkimage}
            alt=""
            className="object-cover "
          />

          <motion.h2
            initial={{ x: 100, opacity: 0 }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            className="text-4xl font-bold text-center absolute w-full py-4 bottom-0 inset-x-0 bg-secondary text-white"
          >
            Drinks Menu
          </motion.h2>
        </Link>
      </motion.div>
    </div>
  );
}

export default Menu;
